/**
 * Single source of truth for classifying a Project's source type.
 *
 * Source type is derived from the project's Partner.organizationType — NOT from
 * the legacy `category` field. Use this everywhere a project needs to be
 * bucketed as NPS / Industry / Military-Gov (admin pages, public opportunities
 * pages, badges, filters).
 */

export type ProjectSourceType = 'NPS' | 'Industry' | 'Military/Gov';

type PartnerLike = { organizationType?: string | null };

export type ProjectSourceInput = {
  partner?: PartnerLike | null;
};

export function getProjectSourceType(project: ProjectSourceInput): ProjectSourceType {
  const orgType = project.partner?.organizationType?.toLowerCase();
  if (!orgType || orgType === 'nps') return 'NPS';
  if (orgType === 'industry') return 'Industry';
  return 'Military/Gov';
}

export function isNpsProject(project: ProjectSourceInput): boolean {
  return getProjectSourceType(project) === 'NPS';
}
